// Product page prefetch — desktop hover-intent + mobile viewport dwell + touchstart
// Skips prefetching on slow connections and Save-Data mode.

const prefetched = new Set();

function shouldPrefetch() {
  const conn = navigator.connection;
  if (!conn) return true;
  return !conn.saveData && !['slow-2g', '2g'].includes(conn.effectiveType);
}

function prefetch(url) {
  if (prefetched.has(url) || !shouldPrefetch()) return;
  prefetched.add(url);
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.as = 'document';
  link.href = url;
  document.head.appendChild(link);
}

// Desktop: hover-intent — 100ms delay filters accidental mouseovers
function onPointerEnter(event) {
  if (!(event.target instanceof Element)) return;
  const anchor = event.target.closest('.product-card__link');
  if (!anchor || !anchor.href) return;
  const timer = setTimeout(() => prefetch(anchor.href), 100);
  anchor.addEventListener('pointerleave', () => clearTimeout(timer), { once: true });
}
document.addEventListener('pointerenter', onPointerEnter, { capture: true, passive: true });

// Mobile: touchstart fires ~100ms before navigation completes — immediate fetch
function onTouchStart(event) {
  const anchor = event.target.closest('.product-card__link');
  if (anchor?.href) prefetch(anchor.href);
}
document.addEventListener('touchstart', onTouchStart, { capture: true, passive: true });

// All devices: IntersectionObserver — prefetch cards that dwell in viewport for 300ms
const dwellTimers = new WeakMap();
const observer = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    const anchor = entry.target.querySelector('.product-card__link');
    if (!anchor?.href) continue;
    if (entry.isIntersecting) {
      dwellTimers.set(entry.target, setTimeout(() => prefetch(anchor.href), 300));
    } else {
      clearTimeout(dwellTimers.get(entry.target));
    }
  }
}, { threshold: 0.5 });

document.querySelectorAll('product-card').forEach(card => observer.observe(card));
